import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloClass, KiloClassWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateClass(): UseMutationResult<
  AxiosResponse<KiloClass>,
  AxiosError<ErrorMessage>,
  KiloClassWrite
> {
  const queryClient = useQueryClient();

  const updateKiloClass = (payload: KiloClassWrite): Promise<AxiosResponse<KiloClass>> => {
    return client.put(`kilo-classes/${payload?.kiloClassId}/`, payload);
  };

  return useMutation(updateKiloClass, {
    onSuccess: () => {
      queryClient.invalidateQueries(['classes']);
      queryClient.invalidateQueries('events');
      queryClient.invalidateQueries(['workouts', 'calendar']);
    },
  });
}
